export const createStyles = (theme: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  return {
    container: {
      position: 'relative',
      width: { xs: 343, sm: 360, md: 560 },
      padding: '1rem 1rem',
      bgcolor: 'background.paper',
      borderRadius: '8px',
      height: '695px',
      maxHeight: 'calc(100dvh - 2rem)',
      fontFamily: theme?.typography?.fontFamily,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    header: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      gap: '8px',
      minHeight: '44px',
    },
    title: {
      m: 0,
      lineHeight: 1.5,
      fontSize: '20px',
      fontWeight: 500,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: { xs: '-webkit-box', md: 'block' },
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 1,
      whiteSpace: { xs: 'normal', md: 'nowrap' },
      overflowWrap: 'anywhere',
    },
    cohortBackTitle: {
      lineHeight: 1.5,
      fontSize: '16px',
      fontWeight: 500,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: { xs: '-webkit-box', md: 'block' },
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 1,
      whiteSpace: { xs: 'normal', md: 'nowrap' },
      overflowWrap: 'anywhere',
      textAlign: 'left',
    },
    content: {
      flex: 1,
      minHeight: 0,
      overflowY: 'scroll',
      pt: '12px',
      pb: '20px',
    },
    studentsContent: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    studentsStep: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
      '& > :not(ul)': { flexShrink: 0 },
    },
    extensionCount: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      fontSize: '16px',
      fontWeight: 500,
      mb: '16px',
      pb: '12px',
    },
    nameInput: {
      m: 0,
      '& .MuiInputBase-root': {
        fontSize: '16px',
        height: '48px',
      },
      '& .MuiFormHelperText-root': {
        fontSize: '12px',
        mb: '22px',
        mt: '10px',
      },
    },
    extensionNameTextField: {
      m: '0px',
      mb: '22px',
      height: '48px',
      '& .MuiFormHelperText-root': {
        fontSize: '12px',
        marginTop: '10px',
        mx: '0px',
        mb: '0px',
        color: isDark ? '#FFFFFFB2' : '#00000099',
      },
    },
    otherCohortsButton: {
      background: 'none',
      border: 0,
      padding: 0,
      fontFamily: 'inherit',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px',
      color: theme.palette.primary.main,
      fontSize: '13px',
      fontWeight: '500',
      cursor: 'pointer',
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: '4px',
      },
    },
    summaryHeader: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      mt: '22px',
    },
    sectionTitle: { fontSize: '16px', fontWeight: 500 },
    chip: {
      alignSelf: 'flex-start',
      bgcolor: 'action.selected',
      borderRadius: '18px',
      display: 'inline-flex',
      mt: '14px',
      mb: '12px',
      px: '12px',
      py: '6px',
      fontSize: '13px',
    },
    searchInput: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '4px',
      fontSize: '16px',
      height: '48px',
      mb: '12px',
      px: '12px',
      '&:focus-within': { borderColor: 'primary.main', borderWidth: '1px' },
    },
    searchIcon: { color: isDark ? '#FFFFFF8F' : '#231F298F', mr: '10px' },
    studentList: {
      flex: 1,
      minHeight: 0,
      listStyle: 'none',
      m: 0,
      p: 0,
      overflowY: 'auto',
      overscrollBehaviorY: 'contain',
    },
    cohortTitle: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      fontSize: '16px',
      fontWeight: 500,
      mb: 0,
      pb: '16px',
    },
    properties: { display: 'flex', flexDirection: 'column', gap: '16px' },
    field: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '4px',
      display: 'flex',
      minHeight: '48px',
      fontSize: '16px',
      px: '12px',
      position: 'relative',
      '& input': {
        background: 'transparent',
        border: 0,
        color: 'inherit',
        font: 'inherit',
        outline: 0,
        width: '100%',
      },
    },
    fieldLabel: {
      bgcolor: 'background.paper',
      color: 'text.secondary',
      fontSize: '13px',
      left: '8px',
      px: '4px',
      position: 'absolute',
      top: '-10px',
    },
    descriptionEditor: {
      height: '130px',
      boxSizing: 'border-box',
      overflowY: 'auto',
      py: '12px',
      width: '100%',
      fontFamily: 'Roboto, sans-serif',
      color: isDark ? theme.palette.common.white : theme.palette.text.primary,
      '& [data-slate-editor="true"]': {
        fontFamily: 'Roboto, sans-serif',
        color: isDark ? theme.palette.common.white : theme.palette.text.primary,
        minHeight: '100%',
      },
      '& [data-slate-string], & [data-slate-placeholder]': {
        fontFamily: 'Roboto, sans-serif',
        color: isDark ? theme.palette.common.white : theme.palette.text.primary,
      },
      '& p': {
        marginTop: '8px',
        marginBottom: '8px',
      },
    },
    descriptionTextField: {
      minHeight: '152px',
    },
    editedHelperText: {
      color: 'text.secondary',
      fontSize: '12px',
      lineHeight: '14px',
      minHeight: '14px',
      mt: '10px',
    },
    dateFields: {
      display: 'grid',
      rowGap: '16px',
    },
    switchRow: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    checkboxStyle: {
      '&.MuiFormControlLabel-root': {
        marginRight: 0,
        flexShrink: 0,
      },
    },
    dateField: {
      cursor: 'pointer',
      m: 0,
    },
    datePickerContainer: {
      bgcolor: 'background.paper',
      borderRadius: 2,
      boxShadow: 24,
      maxWidth: '95vw',
      overflow: 'hidden',
      width: 320,
    },
    datePickerTitle: {
      color: 'text.secondary',
      fontSize: '12px',
      fontWeight: 500,
      letterSpacing: '0.08em',
      px: 2,
      pt: 1.5,
    },
    dateTimePicker: {
      boxShadow: 'none',
      width: '100%',
      '& .MuiPickersDay-root.Mui-selected:hover': {
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
      },
    },
    datePickerActions: {
      display: 'flex',
      gap: 1,
      justifyContent: 'flex-end',
      pb: 1.5,
      pt: 0.5,
      px: 2,
    },
    propertiesInfo: {
      backgroundColor: isDark ? '#071318' : '#E5F6FD',
      color: isDark ? '#B8E7FB' : '#014361',
    },
    editedPropertiesAlert: {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    conflictContent: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      minHeight: 0,
      height: '100%',
      pt: '12px',
    },
    conflictTitle: { fontSize: '18px', fontWeight: 500, mb: '16px' },
    conflictStudents: {
      flex: 1,
      listStyle: 'none',
      m: 0,
      minHeight: 0,
      mt: '12px',
      overflowY: 'auto',
      overscrollBehaviorY: 'contain',
      p: 0,
    },
    conflictActions: {
      display: 'flex',
      flexShrink: 0,
      justifyContent: 'flex-end',
      pt: '16px',
    },
    footer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      pt: '16px',
    },
    actionButtons: { display: 'flex', gap: '16px' },
    cohortBackButton: {
      flex: 1,
      background: 'none',
      border: 0,
      padding: 0,
      fontFamily: 'inherit',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: '8px',
      minWidth: 0,
      overflow: 'hidden',
      cursor: 'pointer',
      color: theme.palette.primary.main,
    },
  };
};
